import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

export interface FlowchartConfirmExitWithUnsavedChangesModalProps {
  onRequestSubmit: () => void;
  onRequestKeepEditing: () => void;
  onRequestLeaveWithoutSaving: () => void;
  onRequestClose: () => void;
  title?: string;
  subTitle?: string;
}

const DEFAULT_TITLE = 'Discard unsaved edits?';
const DEFAULT_SUB_TITLE = 'If you continue, you will lose your unsaved edits.';

export default function FlowchartConfirmExitWithUnsavedChangesModal(
  props: FlowchartConfirmExitWithUnsavedChangesModalProps
): JSX.Element {
  const {subTitle = DEFAULT_SUB_TITLE, title = DEFAULT_TITLE} = props;

  return (
    <Modal
      title={title}
      flexContent={true}
      buttons={[
        {
          text: 'Discard edits',
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            props.onRequestLeaveWithoutSaving();
            props.onRequestClose();
          },
        },
        {
          text: 'Save and exit',
          submit: true,
          style: ButtonStyle.PRIMARY,
        },
      ]}
      onRequestSubmit={() => {
        props.onRequestSubmit();
      }}
      onRequestClose={() => {
        props.onRequestKeepEditing();
        props.onRequestClose();
      }}
    >
      <p className={css(styles.subTitle)}>{subTitle}</p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  subTitle: {
    fontSize: '14px',
  },
});
